import '../styles/components/Services.css';
import { m } from 'framer-motion';
import { fadeUp, staggerContainer, staggerItem, viewport } from '../motion/variants';

const services = [
  {
    title: 'Selling Land Plots',
    imageSrc: '/img/land.jpeg',
    description:
      'We provide affordable and strategically located land plots suitable for residential, commercial, and investment purposes. Our plots are carefully selected to offer accessibility, security, and long-term value for individuals, businesses, and property developers.',
    bullets: [
      'Residential, commercial & investment plots',
      'Accessible and secure locations',
      'Long-term value for developers',
    ],
  },
  {
    title: 'Providing Building Materials',
    imageSrc: '/img/bricks.jpg',
    description:
      'ABL Construction Limited supplies high-quality building materials including cement, sand, kokoto, blocks, stones, and other construction essentials. We ensure reliable supply, competitive pricing, and timely delivery to support construction projects of every scale.',
    bullets: [
      'Cement, sand, kokoto, blocks & stones',
      'Competitive pricing & reliable supply',
      'Timely delivery to your site',
    ],
  },
  {
    title: 'Residential and Commercial Construction Services',
    imageSrc: '/img/abl10.jpeg',
    description:
      'We offer professional residential and commercial construction services tailored to meet client needs with quality workmanship and efficient project execution. From planning to completion, we are committed to delivering durable, modern, and cost-effective construction solutions.',
    bullets: [
      'Residential & commercial projects',
      'Quality workmanship & efficient delivery',
      'Planning through to completion',
    ],
  },
];

function Services() {
  return (
    <section className="services" id="services">
      <div className="services-inner">
        <m.header
          className="services-header"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={fadeUp}
        >
          <h2>Our Services</h2>
          <p>
            At ABL Construction Limited, we are committed to delivering reliable, high-quality, and
            cost-effective construction support services across Tanzania. With a focus on
            efficiency, durability, and customer satisfaction, we provide trusted solutions for
            construction projects of every scale.
          </p>
        </m.header>

        <m.div
          className="services-cards"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={staggerContainer}
        >
          {services.map((service, index) => (
            <div className="service-sticky" key={service.title}>
              <m.article
                className={`service-card ${index % 2 === 1 ? 'reverse' : ''}`}
                variants={staggerItem}
                whileHover={{ y: -4 }}
                transition={{ type: 'spring', stiffness: 400, damping: 28 }}
              >
                <div className="service-content">
                  <div className="service-step">Service {String(index + 1).padStart(2, '0')}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <ul className="service-bullets">
                    {service.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                </div>

                <div className="service-media" aria-hidden="true">
                  <img src={service.imageSrc} alt="" loading="lazy" />
                </div>
              </m.article>
            </div>
          ))}
        </m.div>
      </div>
    </section>
  );
}

export default Services;
